import L from "react";
import { BaseLink as b } from "./base-link.esm.js";
const N = ({
  centreAlign: l = !1,
  children: s = null,
  className: e,
  dataTestId: n = null,
  disabled: t,
  href: r,
  icon: f,
  iconRight: o = !1,
  isButton: a = !1,
  size: u = "large",
  standalone: i = !1,
  underline: m = !0,
  white: c = !1,
  ...k
}) => {
  const d = a ? "button" : "a", p = e ? `fuse-link ${e}` : "fuse-link";
  return /* @__PURE__ */ L.createElement(
    b,
    {
      as: d,
      centreAlign: l,
      className: p,
      dataTestId: n,
      disabled: t,
      href: r,
      icon: f,
      iconRight: o,
      isButton: a,
      size: u,
      standalone: i,
      underline: m,
      white: c,
      focusable: !0,
      ...k
    },
    s
  );
};
N.displayName = "Link";
export {
  N as StandardLink
};
